// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2EX29","boxTitle":"Qualiphy_boxTitle__20CRK","box":"Qualiphy_box__15QZN","toggleWrap":"Qualiphy_toggleWrap__34k_c"};